import { Button, Dropdown, Form, Input, Menu, Modal, Space, Spin, Switch, Table, Tabs } from 'antd';
import { PlusOutlined, ReloadOutlined } from '@ant-design/icons';
import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import {
    DELETERestaurant,
    ListRestauantByADmin,
    exportVenuesCSVAction,
    getArchivedVenueListAction,
    reportedRestaurantActiveInactive,
    restoreVenueAction,
    UnclaimVenue,
    updateFrnachiseToggle,
} from '../../Redux/RestaurantManagementSlice';
import { CheckIcon, DeleteIcon, DownIcon, EditIcon, Unclaim, ViewIcon } from '../../svg';
import { debounce, getSortOrder } from '../../utils';
import { usePagination } from '../../utils/pagination';

// GRB-1360, Queries sheet Q1: a merge can include at most 6 venues total
// (1 master + 5 duplicates).
const MAX_MERGE_SELECTION = 6;

const RestaurantList = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const { currentPage, onChangePage, onChangePageSize, pageSize, searchTerm, onSearchPagination, clearSearch } = usePagination();
    const { restaurantList, recordsTotal } = useSelector(state => state.restaurant) || {}
    const archivedVenueList = useSelector(state => state?.restaurant?.archivedVenueList) || { list: [], recordsTotal: 0 }

    const [activeTab, setActiveTab] = useState('venues');
    const [archivedLoading, setArchivedLoading] = useState(false);
    const [archivedSearchInput, setArchivedSearchInput] = useState('');
    const [archivedSearch, setArchivedSearch] = useState('');
    const [archivedPage, setArchivedPage] = useState(1);
    const [archivedPageSize, setArchivedPageSize] = useState(10);

    const [archiveModalId, setArchiveModalId] = useState();
    const [archiveModalOpen, setArchiveModalOpen] = useState(false);
    const [loading, setLoading] = useState(false)
    const [inputValue, setInputValue] = useState(searchTerm);
    const [selectedIds, setSelectedIds] = useState([]);
    const [unclaimModalId, setUnclaimModalId] = useState();
    const [unclaimModalOpen, setUnclaimModalOpen] = useState(false);
    const [restoreModalRecord, setRestoreModalRecord] = useState(null);
    const [restoreModalOpen, setRestoreModalOpen] = useState(false);
    // GRB-1360: one UUID v4 per restore operation; reused if the network
    // fails mid-flight so the backend can detect and ignore the duplicate.
    const [restoreIdempotencyKey, setRestoreIdempotencyKey] = useState(null);

    const [args, setArgs] = useState(
        {
            "search": searchTerm,
            "start": (currentPage - 1) * pageSize,
            "length": pageSize,
        }
    )

    // Debounced fetch data function
    const fetchData = useCallback(debounce((args) => {
        setLoading(true);
        dispatch(ListRestauantByADmin(args))
            .then(() => setLoading(false))
            .catch((error) => {
                setLoading(false);
                toast.error(error.message);
            });
    }, 1000), [dispatch]);

    useEffect(() => {
        if (activeTab === 'venues') fetchData(args);
    }, [args, fetchData, activeTab]);

    useEffect(() => {
        setArgs({
            search: searchTerm,
            start: (currentPage - 1) * pageSize,
            length: pageSize,
            sort: args?.sort === "" ? undefined : args?.sort,
            dir: args?.dir
        });
    }, [searchTerm, currentPage, pageSize, args?.sort, args?.dir]);

    // GRB-1360: Archived tab — separate search/pagination state, fetched only while that tab is active.
    const fetchArchivedVenues = useCallback((search, page, pageSize) => {
        setArchivedLoading(true);
        dispatch(getArchivedVenueListAction({
            search,
            start: (page - 1) * pageSize,
            length: pageSize,
        }))
            .then(() => setArchivedLoading(false))
            .catch((error) => {
                toast.error(error?.message);
                setArchivedLoading(false);
            });
    }, [dispatch]);

    useEffect(() => {
        if (activeTab === 'archived') fetchArchivedVenues(archivedSearch, archivedPage, archivedPageSize);
    }, [activeTab, archivedSearch, archivedPage, archivedPageSize, fetchArchivedVenues]);

    const debouncedArchivedSearch = useCallback(debounce((value) => {
        setArchivedSearch(value);
        setArchivedPage(1);
    }, 800), []);

    const handleArchivedSearchChange = (e) => {
        setArchivedSearchInput(e.target.value);
        debouncedArchivedSearch(e.target.value);
    };


    const onChange = (e, row) => {
        setLoading(true)
        const statusRequest = {
            restaurantId: row?._id,
            isFranchise: e
        }
        dispatch(updateFrnachiseToggle(statusRequest))
            .then(response => {
                if (response) {
                    setLoading(false)
                }
                setLoading(true)
                dispatch(ListRestauantByADmin(args)).then((response) => {
                    if (response) {
                        setLoading(false)
                    }
                })
                toast.success(response.message, {
                    position: toast.POSITION.TOP_RIGHT
                });
            })
            .catch(err => {
                setLoading(false)
                toast.error(err)
            })

    };

    const showArchiveModal = (record) => {
        setArchiveModalOpen(true);
        setArchiveModalId(record?._id)
    };


    const onChangeVenueActiveInactive = (row) => {
        const statusRequest = {
            id: row?._id
        }
        setLoading(true)
        dispatch(reportedRestaurantActiveInactive(statusRequest))
            .then(response => {
                setLoading(false)
                dispatch(ListRestauantByADmin(args))
                toast.success(response.message, {
                    position: toast.POSITION.TOP_RIGHT
                });
            })
            .catch(err => {
                toast.error(err.message)
                setLoading(false)
            })

    };


    const handleUnclaimVenue = (record) => {
        setUnclaimModalOpen(true)
        setUnclaimModalId(record)
    }
    const handleUnclaimCancel = () => {
        setUnclaimModalOpen(false)
    }

    const handleUnclaimOk = () => {
        setUnclaimModalOpen(false)
        dispatch(UnclaimVenue({ venueId: unclaimModalId?._id }))
            .then((response) => {
                toast.success(response.message);
                dispatch(ListRestauantByADmin(args)).then((response) => {
                    if (response) {
                        setLoading(false)
                    }
                }).catch((err) => toast.error(err?.message))
            })
            .catch((error) => toast.error(error.message));
    }

    const handleRestoreClick = (record) => {
        setRestoreModalRecord(record);
        // Generate a fresh key for each new restore operation.
        setRestoreIdempotencyKey(crypto.randomUUID());
        setRestoreModalOpen(true);
    };

    const handleRestoreCancel = () => {
        setRestoreModalOpen(false);
        setRestoreModalRecord(null);
        setRestoreIdempotencyKey(null);
    };

    const handleRestoreOk = () => {
        const restaurantId = restoreModalRecord._id || restoreModalRecord.restaurantId;
        console.log('[GRB-1360][RESTORE] Sending restore request', { restaurantId, idempotencyKey: restoreIdempotencyKey });
        // Keep the modal open while the request is in-flight so the user can
        // retry on timeout/network failure with the same idempotencyKey.
        dispatch(restoreVenueAction({ restaurantId, idempotencyKey: restoreIdempotencyKey }))
            .then(response => {
                console.log('[GRB-1360][RESTORE] Success', { restaurantId, message: response.message });
                toast.success(response.message);
                setRestoreModalOpen(false);
                setRestoreModalRecord(null);
                setRestoreIdempotencyKey(null);
                fetchArchivedVenues(archivedSearch, archivedPage, archivedPageSize);
            })
            .catch((error) => {
                // Leave modal open — user can retry with the same idempotencyKey.
                toast.error(error?.message);
            });
    };

    // GRB-1360, Admin CMS #5: checkbox selection with the 5-venue cap and the
    // "X Venues Selected | Merge | Clear" action bar (only shown when >= 2 selected).
    const rowSelection = {
        selectedRowKeys: selectedIds,
        onChange: (keys) => {
            const currentPageIds = (restaurantList || []).map(r => r._id);
            const otherPageIds = selectedIds.filter(id => !currentPageIds.includes(id));
            const merged = [...otherPageIds, ...keys];

            console.log('[GRB-1360][SELECTION] Updated', {
                currentPageSelected: keys,
                keptFromOtherPages: otherPageIds,
                totalSelected: merged,
            });

            if (merged.length > MAX_MERGE_SELECTION) {
                toast.error(`You can select at most ${MAX_MERGE_SELECTION} venues to merge at once.`);
                return;
            }
            setSelectedIds(merged);
        },
        getCheckboxProps: (record) => ({
            disabled: selectedIds.length >= MAX_MERGE_SELECTION && !selectedIds.includes(record._id),
        }),
    };

    const handleMergeClick = () => {
        navigate('/restaurants/merge-workspace', { state: { selectedIds } });
    };

    const handleClearSelection = () => setSelectedIds([]);

    // GRB-1360, Admin CMS #6: Export CSV dropdown — current (search-filtered) view
    // vs. full database. Filename is set client-side via the <a download> attribute
    // inside exportVenuesCSVAction.
    const handleExport = (exportType) => {
        dispatch(exportVenuesCSVAction({
            exportType,
            // 'current' mirrors exactly what's on screen right now (search +
            // pagination window); 'full' ignores these — the backend always
            // exports the entire database and emails it instead of downloading.
            search: exportType === 'current' ? args.search : undefined,
            start: exportType === 'current' ? args.start : undefined,
            length: exportType === 'current' ? args.length : undefined,
        }))
            .then((response) => {
                // Only the 'full' branch resolves with a response body (an email
                // confirmation) — 'current' triggers a direct browser download instead.
                if (response?.message) {
                    toast.success(response.message);
                }
            })
            .catch((error) => toast.error(error?.message || 'Export failed. Please try again.'));
    };

    const exportMenu = (
        <Menu
            className='export-csv-menu'
            onClick={({ key }) => handleExport(key)}
            items={[
                { key: 'current', label: 'Export Current View' },
                { key: 'full', label: 'Export Full Database' },
            ]}
        />
    );

    const columns = [
        {
            title: "Owner Name",
            dataIndex: "venueOwnerName",
            key: "venueOwnerName",
            className: 'ant-th-venue ant-regular',
            render: (row, record) => (
                <div className='location'>
                    {record?.venueOwnerName ? record?.venueOwnerName : "N/A"}
                </div>
            ),
        },
        {
            title: "Venue Name",
            dataIndex: "name",
            key: "name",
            className: 'ant-th-venue ant-regular',
            sorter: true,
            render: (row, record) => (
                <div className='location'>
                    {record?.name}
                </div>
            ),
        },
        {
            title: "Email",
            dataIndex: "email",
            key: "email",
            className: 'ant-th-venue ant-regular',
            sorter: true,
            render: (row, record) => (
                <div className='location'>
                    {record?.email ? record?.email : "-"}
                </div>
            ),
        },
        {
            title: "Location",
            dataIndex: "address",
            key: "address",
            className: 'ant-th-venue ant-regular',
            sorter: true,
            render: (row, record) => (
                <div className='location'>
                    {record?.address ? record?.address : "-"}
                </div>
            ),
        },

        {
            title: "Goat",
            dataIndex: "totalGoats",
            key: "totalGoats",
            sorter: true,
            className: 'ant-th-venue',
            render: (row, record) => (
                <div className='number'>
                    {record?.totalGoats}
                </div>
            ),
        },
        {
            title: "Franchise Name",
            dataIndex: "restaurantFranchise",
            key: "restaurantFranchise",
            className: "ant-th-venue",
            render: (row, record) => (
                <div>{record?.restaurantFranchise?.name ? record?.restaurantFranchise?.name : "-"}</div>
            ),
        },
        {
            title: "Is this a franchise?",
            className: 'ant-th-venue',
            render: (cell, row) => <Space size={10}>
                <Switch onChange={(e) => { onChange(e, row) }} checked={row?.isRestaurantFranchise === true ? true : false} />

            </Space>
        },
        {
            title: 'Actions',
            dataIndex: 'action',
            key: 'action',
            width: 100,
            className: "action ant-th-venue",
            render: (cell, row) => <Space size={10}>
                <Switch onChange={() => onChangeVenueActiveInactive(row)} checked={row?.isActive === true ? true : false} />

                <Button htmlType="submit" className='view-btn' onClick={() => navigate('/viewrestaurant', {
                    state: {
                        record: row
                    }
                })}><ViewIcon /></Button>
                <Button htmlType="submit" className='edit-btn' onClick={() =>
                    navigate('/editrestaurant', {
                        state: {
                            record: row
                        }

                    })}><EditIcon /></Button>
                <Button htmlType="submit"
                    className='delete-btn'
                    onClick={() => showArchiveModal(row)} >
                    <DeleteIcon /></Button>

                {row?.isClaimed === true ?
                    <Button
                        htmlType="submit"
                        className='unclaim-btn'
                        onClick={() => handleUnclaimVenue(row)}
                    >
                        <Unclaim />
                    </Button> : null
                }
            </Space>
        },
    ];

    // GRB-1360, Admin CMS #7: same shape of columns as the Venues tab, but the
    // franchise toggle is read-only here (archived venues are not active), and
    // Actions only offers Restore — no edit/view/delete/unclaim on an archived row.
    const archivedColumns = [
        { title: 'Owner Name', dataIndex: 'ownerName', key: 'ownerName', render: (v) => <div>{v || 'N/A'}</div> },
        { title: 'Venue Name', dataIndex: 'venueName', key: 'venueName', render: (v) => <div>{v}</div> },
        { title: 'Email', dataIndex: 'email', key: 'email', render: (v) => <div>{v || '-'}</div> },
        { title: 'Location', dataIndex: 'location', key: 'location', render: (v) => <div>{v || '-'}</div> },
        { title: 'Goat', dataIndex: 'goatCount', key: 'goatCount', render: (v) => <div>{v ?? 0}</div> },
        { title: 'Franchise Name', dataIndex: 'franchiseName', key: 'franchiseName', render: (v) => <div>{v || '-'}</div> },
        {
            title: 'Is this a franchise?',
            dataIndex: 'isFranchise',
            key: 'isFranchise',
            render: (value) => <Switch checked={!!value} disabled />,
        },
        {
            title: 'Archived On',
            dataIndex: 'archivedAt',
            key: 'archivedAt',
             render: (value) =>
       value
          ? new Date(value).toLocaleDateString("en-US", {
              month: "2-digit",
              day: "2-digit",
              year: "numeric",
            })
          : "—",
            // render: (value) => <div>{value ? new Date(value).toLocaleDateString() : '-'}</div>,
        },

       
        {
            title: 'Actions',
            dataIndex: 'action',
            key: 'action',
            width: 80,
            render: (cell, record) => (
                <Button htmlType="submit" className='restore-btn' title="Restore"
                    onClick={() => handleRestoreClick(record)}>
                    <ReloadOutlined />
                </Button>
            ),
        },
    ];

    const onTableChange = (newState, _, sorter) => {
        const { current, pageSize } = newState;
        onChangePage(current);
        onChangePageSize(pageSize);
        setArgs({
            ...args,
            start: Number(current - 1) * pageSize,
            length: pageSize,
            sort: sorter?.order === undefined ? "" : sorter.field,
            dir: getSortOrder(sorter.order)
        })
    }

    const onArchivedTableChange = (newState) => {
        const { current, pageSize } = newState;
        setArchivedPage(current);
        setArchivedPageSize(pageSize);
    };

    const handleArchiveCancel = () => {
        setArchiveModalOpen(false);
    };
    const handleArchiveOk = () => {
        setArchiveModalOpen(false);
        dispatch(DELETERestaurant({ id: archiveModalId }))
            .then(response => {
                toast.success(response.message)
                setSelectedIds((prev) => prev.filter((id) => id !== archiveModalId));
                dispatch(ListRestauantByADmin(args))
            })
            .catch((error) => toast.error(error?.message))
    };

    const debouncedOnSearch = useCallback(debounce((value) => {
        if (value === "") {
            clearSearch();
        } else {
            onSearchPagination(value);
        }
    }, 2000), []);

    const handleSearchChange = (e) => {
        setInputValue(e.target.value);
        debouncedOnSearch(e.target.value);
    };


    const venuesTab = (
        <>
            <div className='search-group d-flex align-items-center justify-content-between'>
                <Form.Item>
                    <Input type='text' placeholder="Search" onChange={handleSearchChange} value={inputValue} />
                </Form.Item>
                <div className='btn-group d-flex align-items-center justify-content-end'>
                    <Dropdown disabled={restaurantList?.length <= 0} overlay={exportMenu} trigger={['click']}>
                        <Button className='export-csv-btn'>Export CSV <DownIcon /></Button>
                    </Dropdown>
                    <Button type="primary" onClick={() => navigate('/addrestaurant')}>Add</Button>
                </div>
            </div>
            {selectedIds.length >= 2 && (
                <div className='selection-action-bar d-flex align-items-center' style={{ background: '#FEF6EF', padding: '10px 16px', marginBottom: 12, borderRadius: 6, gap: 24 }}>
                    <span className='d-flex align-items-center' style={{ gap: 8, fontWeight: 600 }}><CheckIcon /> {selectedIds.length} Venues Selected</span>
                    <Space size={16} align="center">
                        <Button type="primary" onClick={handleMergeClick}>Merge</Button>
                        <Button
                            type="text"
                            className="venue-clear-btn"
                            onClick={handleClearSelection}
                            style={{ color: '#8C8C8C', border: 'none', boxShadow: 'none', padding: '4px 8px', height: 'auto' }}
                        >
                            Clear
                        </Button>
                    </Space>
                </div>
            )}
            <Table
                rowKey="_id"
                rowSelection={rowSelection}
                columns={columns}
                dataSource={restaurantList ? restaurantList : []}
                pagination={{
                    defaultPageSize: 10,
                    showSizeChanger: true,
                    pageSizeOptions: [5, 10, 20, 50, 100],
                    total: recordsTotal || 0,
                    pageSize: pageSize,
                    current: currentPage
                }}
                onChange={onTableChange}
                scroll={{ x: 1200 }}
                loading={{ indicator: <div><Spin size='large' /></div>, spinning: loading }}
            />
        </>
    );

    const archivedTab = (
        <>
            <div className='search-group d-flex align-items-center justify-content-between'>
                <Form.Item>
                    <Input type='text' placeholder="Search" onChange={handleArchivedSearchChange} value={archivedSearchInput} />
                </Form.Item>
            </div>
            <Table
                rowKey="restaurantId"
                columns={archivedColumns}
                dataSource={archivedVenueList?.list || []}
                pagination={{
                    current: archivedPage,
                    pageSize: archivedPageSize,
                    total: archivedVenueList?.recordsTotal || 0,
                    showSizeChanger: true,
                    pageSizeOptions: [5, 10, 20, 50, 100],
                }}
                onChange={onArchivedTableChange}
                scroll={{ x: 1200 }}
                loading={{ indicator: <div><Spin size='large' /></div>, spinning: archivedLoading }}
            />
        </>
    );

    return (
        <>
            <div className='shadow-paper'>
                <Tabs
                    activeKey={activeTab}
                    onChange={setActiveTab}
                    items={[
                        { key: 'venues', label: 'Venues', children: venuesTab },
                        { key: 'archived', label: 'Archived', children: archivedTab },
                    ]}
                />
            </div>
            <Modal
                title="Delete Restaurant"
                open={archiveModalOpen}
                className='common-modal'
                width={448}
                centered
                onOk={handleArchiveOk}
                onCancel={handleArchiveCancel}
                footer={[
                    <Space size={10} className='justify-content-end'>
                        <Button type="seconadary" onClick={handleArchiveCancel} >No</Button>
                        <Button type="primary" onClick={handleArchiveOk}>Yes</Button>
                    </Space>
                ]}
            >
                <Form>
                    <p>Are you sure you want to delete?.</p>
                </Form>
            </Modal>

            <Modal
                title="Venue unclaim"
                open={unclaimModalOpen}
                className='common-modal'
                width={448}
                centered
                onOk={handleUnclaimOk}
                onCancel={handleUnclaimCancel}
                footer={[
                    <Space size={10} className='justify-content-end'>
                        <Button type="seconadary" onClick={handleUnclaimCancel} >No</Button>
                        <Button type="primary" onClick={handleUnclaimOk}>Yes</Button>
                    </Space>
                ]}
            >
                <Form>
                    <p>Are you sure you want to unclaim this venue?</p>
                </Form>
            </Modal>

            <Modal
                title="Restore venue"
                open={restoreModalOpen}
                className='common-modal'
                width={448}
                centered
                onOk={handleRestoreOk}
                onCancel={handleRestoreCancel}
                footer={[
                    <Space size={10} className='justify-content-end'>
                        <Button type="seconadary" onClick={handleRestoreCancel}>No</Button>
                        <Button type="primary" onClick={handleRestoreOk}>Yes</Button>
                    </Space>
                ]}
            >
                <Form>
                    <p>Restore this venue? It will be visible in the app again.</p>
                    {restoreModalRecord?.archivedAt && (() => {
                        const deadline = new Date(
                            new Date(restoreModalRecord.archivedAt).getTime() + 30 * 24 * 60 * 60 * 1000
                        );
                        return (
                            <p style={{ color: '#be1e2d', fontSize: 13, marginTop: 8 }}>
                                Restore deadline: {deadline.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' })}
                            </p>
                        );
                    })()}
                </Form>
            </Modal>
        </>
    );
}

export default RestaurantList
